"use strict";
exports.__esModule = true;
exports.createPushpinDataSource = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var geoChartColor_1 = require("./geoChartColor");
var geoChart_1 = require("./constants/geoChart");
var common_1 = require("./helpers/geoChart/common");
function transformPushpinDataSource(dataSourceProps) {
    var _a, _b, _c, _d, _e, _f, _g;
    var config = dataSourceProps.config, geoData = dataSourceProps.geoData, colorStrategy = dataSourceProps.colorStrategy;
    var color = geoData.color, location = geoData.location, segment = geoData.segment, size = geoData.size, tooltipText = geoData.tooltipText;
    if (!location) {
        /*
         * short-circuit the processing at this point. if there is no location data then the features will
         * be empty
         */
        return [];
    }
    var _h = (config || {}).points, geoPointsConfig = _h === void 0 ? {} : _h;
    var locationNameTitle = tooltipText ? tooltipText.name : "";
    var colorTitle = color ? color.name : "";
    var sizeTitle = size ? size.name : "";
    var segmentTitle = segment ? segment.name : "";
    var hasSize = size !== undefined;
    var locationData = location.data;
    var locationNameData = (_a = tooltipText === null || tooltipText === void 0 ? void 0 : tooltipText.data) !== null && _a !== void 0 ? _a : [];
    var segmentData = (_b = segment === null || segment === void 0 ? void 0 : segment.data) !== null && _b !== void 0 ? _b : [];
    var segmentUris = (_c = segment === null || segment === void 0 ? void 0 : segment.uris) !== null && _c !== void 0 ? _c : [];
    var sizeData = (_d = size === null || size === void 0 ? void 0 : size.data) !== null && _d !== void 0 ? _d : [];
    var _j = common_1.getMinMax(sizeData), minSizeFromData = _j.min, maxSizeFromData = _j.max;
    var colorData = (_e = color === null || color === void 0 ? void 0 : color.data) !== null && _e !== void 0 ? _e : [];
    var sizeFormat = (_f = size === null || size === void 0 ? void 0 : size.format) !== null && _f !== void 0 ? _f : "";
    var colorFormat = (_g = color === null || color === void 0 ? void 0 : color.format) !== null && _g !== void 0 ? _g : "";
    var pushpinColors = geoChartColor_1.getPushpinColors(colorData, segmentData, colorStrategy);
    return locationData.reduce(function (result, coordinates, index) {
        if (!coordinates) {
            return result;
        }
        var lat = coordinates.lat, lng = coordinates.lng;
        var pushpinSize = hasSize
            ? calculateSizeInPixel(sizeData[index], minSizeFromData, maxSizeFromData, geoPointsConfig)
            : geoChart_1.PUSHPIN_SIZE_OPTIONS_MAP.min["default"];
        var colorValue = colorData[index];
        var segmentValue = segmentData[index];
        var segmentUri = segmentUris[index];
        var pushpinColor = pushpinColors[index] || pushpinColors[0] || {};
        result.push({
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [lng, lat]
            },
            properties: {
                pushpinSize: pushpinSize,
                locationName: {
                    title: locationNameTitle,
                    value: locationNameData[index]
                },
                locationIndex: index,
                color: tslib_1.__assign(tslib_1.__assign({}, pushpinColor), { title: colorTitle, value: colorValue, format: colorFormat }),
                size: {
                    title: sizeTitle,
                    value: sizeData[index],
                    format: sizeFormat
                },
                segment: {
                    title: segmentTitle,
                    value: segmentValue,
                    uri: segmentUri
                }
            }
        });
        return result;
    }, []);
}
// transform data value to pushpin size in pixel
var calculateSizeInPixel = function (dataValue, minSize, maxSize, geoPointsConfig) {
    if (minSize === maxSize || dataValue === null) {
        return geoChart_1.PUSHPIN_SIZE_OPTIONS_MAP.min["default"];
    }
    var _a = geoPointsConfig || {}, _b = _a.minSize, minSizeFromConfig = _b === void 0 ? "default" : _b, _c = _a.maxSize, maxSizeFromConfig = _c === void 0 ? "default" : _c;
    var minSizeInPixel = geoChart_1.PUSHPIN_SIZE_OPTIONS_MAP.min[minSizeFromConfig];
    var maxSizeInPixel = geoChart_1.PUSHPIN_SIZE_OPTIONS_MAP.max[maxSizeFromConfig];
    return ((dataValue - minSize) * (maxSizeInPixel - minSizeInPixel)) / (maxSize - minSize) + minSizeInPixel;
};
exports.createPushpinDataSource = function (dataSourceProps) {
    var hasClustering = dataSourceProps.hasClustering;
    var source = {
        type: "geojson",
        data: {
            type: "FeatureCollection",
            features: transformPushpinDataSource(dataSourceProps)
        }
    };
    if (hasClustering) {
        return tslib_1.__assign(tslib_1.__assign({}, source), { cluster: true, clusterMaxZoom: geoChart_1.DEFAULT_CLUSTER_MAX_ZOOM, clusterRadius: geoChart_1.DEFAULT_CLUSTER_RADIUS });
    }
    return source;
};
//# sourceMappingURL=geoChartDataSource.js.map